import { useDefaultTranslation } from 'articleEditor/hooks/useDefaultTranslation';
import { LanguageContext } from 'lib-knowledge-management-common/contexts/language';
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';

import { TranslationDataContext } from './translationProvider';

export const RetranslationContext = createContext<Set<string>>(
  new Set<string>(),
);

type RetranslationProviderProps = {
  children: ReactNode;
};

export const RetranslationProvider = ({
  children,
}: RetranslationProviderProps): JSX.Element => {
  const {
    draft: { content: currentArticleContent },
  } = useContext(TranslationDataContext);
  const { currentLanguage, defaultLanguage } = useContext(LanguageContext);
  const defaultTranslation = useDefaultTranslation();
  const [retranslationBlocks, setRetranslationBlocks] = useState(
    new Set<string>(),
  );

  useEffect(() => {
    if (
      defaultLanguage.languageId === currentLanguage ||
      !currentArticleContent
    ) {
      setRetranslationBlocks(new Set<string>());
    } else {
      setRetranslationBlocks(
        new Set(
          currentArticleContent.children
            .filter((child) => {
              const defaultTranslationChild =
                defaultTranslation?.draft.content?.children.find(
                  (c) => c.id === child.id,
                );
              return (
                defaultTranslationChild != undefined &&
                defaultTranslationChild.id === child.id &&
                child.translatedAt != undefined &&
                defaultTranslationChild.updatedAt != undefined &&
                Date.parse(defaultTranslationChild.updatedAt) >=
                  Date.parse(child.translatedAt)
              );
            })
            .map((child) => child.id),
        ),
      );
    }
  }, [
    currentLanguage,
    currentArticleContent,
    defaultLanguage.languageId,
    defaultTranslation,
  ]);

  return (
    <RetranslationContext.Provider value={retranslationBlocks}>
      {children}
    </RetranslationContext.Provider>
  );
};
